import { List, ListIcon, ListItem, SimpleGrid } from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";
import { wpStyles } from "../../theme/wp-styles";
import { Fragment } from "react";

const ListStyleCheckmark = ({ children }) => {
  return (
    <List as={SimpleGrid} columns={{ base: 1, md: 2 }} my={4}>
      {children.map(({ children }, i) => {
        if (children) {
          const text = children[0]?.data;
          return (
            <ListItem key={i} alignItems="center" display="flex" my={2}>
              <ListIcon as={CheckCircleIcon} color={wpStyles.colors.primary} />
              {text}
            </ListItem>
          );
        } else {
          return <Fragment key={i} />;
        }
      })}
    </List>
  );
};

export default ListStyleCheckmark;
